import TagManager from 'react-gtm-module'
import { INDUSTRIES_ES } from '../filters'

export const viewPromotionDataLayer = (offersData, dictionary, skin) => {
  const items = offersData.map((offer) => ({
    nombre_aliado: offer.dv_name,
    nombre_promocion: offer.venue.name,
    categoria_promocion: offer.dv_category,
    // FIXME: Set to undefined until the info is obtained from the backend
    estado: undefined,
    tipo_recompensa: dictionary.CARDS[offer.quickType],
    tipo_negocio: dictionary.CARDS[offer.venue.business_type]
  }))

  const ecommerceItems = offersData.map((offer) => ({
    promotion_id: offer.venue._id,
    promotion_name: offer.venue.name,
    creative_name: offer.dv_cashback,
    creative_slot: offer.dv_category
  }))
  const tagManagerArgs = {
    dataLayer: {
      event: 'ga_event',
      category: 'Home',
      action: 'Impresion promocion',
      label: 'Impresion promocion',
      items,
      // This data is set to undefined in order to clean the dataLayer
      // from the paramaters of previous events
      ecommerce: undefined,
      texto_buscado: undefined,
      nombre_aliado: undefined,
      nombre_promocion: undefined,
      categoria_promocion: undefined,
      estado: undefined,
      tipo_recompensa: undefined,
      tipo_negocio: undefined
    },
    dataLayerName: skin === 'COPPEL' ? 'CoppelDataLayer' : 'DataLayer'
  }
  const ecommerceArgs = {
    dataLayer: {
      event: 'view_promotion',
      ecommerce: { items: ecommerceItems },
      // This data is set to undefined in order to clean the dataLayer
      // from the paramaters of previous events
      items: undefined,
      texto_buscado: undefined,
      nombre_aliado: undefined,
      nombre_promocion: undefined,
      categoria_promocion: undefined,
      estado: undefined,
      tipo_recompensa: undefined,
      tipo_negocio: undefined
    },
    dataLayerName: skin === 'COPPEL' ? 'CoppelDataLayer' : 'DataLayer'
  }
  TagManager.dataLayer(tagManagerArgs)
  TagManager.dataLayer(ecommerceArgs)
}

export const clickPromotionDataLayer = (itemData, dictionary, skin) => {
  const item = {
    nombre_aliado: itemData.dv_name,
    nombre_promocion: itemData.venue.name,
    categoria_promocion: itemData.dv_category,
    // FIXME: Set to undefined until the info is obtained from the backend
    estado: undefined,
    tipo_recompensa: dictionary.CARDS[itemData.quickType],
    tipo_negocio: dictionary.CARDS[itemData.venue.business_type]
  }

  const ecommerceItem = {
    promotion_id: itemData.venue._id,
    promotion_name: itemData.venue.name,
    creative_name: itemData.dv_cashback,
    creative_slot: itemData.dv_category
  }
  const tagManagerArgs = {
    dataLayer: {
      event: 'ga_event',
      category: 'Home',
      action: 'Clic promocion',
      label: 'Clic promocion',
      ...item,
      // This data is set to undefined in order to clean the dataLayer
      // from the paramaters of previous events
      ecommerce: undefined,
      texto_buscado: undefined
    },
    dataLayerName: skin === 'COPPEL' ? 'CoppelDataLayer' : 'DataLayer'
  }
  const ecommerceArgs = {
    dataLayer: {
      event: 'select_promotion',
      ecommerce: { items: [ecommerceItem] },
      // This data is set to undefined in order to clean the dataLayer
      // from the paramaters of previous events
      items: undefined,
      texto_buscado: undefined,
      nombre_aliado: undefined,
      nombre_promocion: undefined,
      categoria_promocion: undefined,
      estado: undefined,
      tipo_recompensa: undefined,
      tipo_negocio: undefined
    },
    dataLayerName: skin === 'COPPEL' ? 'CoppelDataLayer' : 'DataLayer'
  }
  TagManager.dataLayer(tagManagerArgs)
  TagManager.dataLayer(ecommerceArgs)
}

export const filterPromotionDataLayer = (label, skin) => {
  const tagManagerArgs = {
    dataLayer: {
      event: 'ga_event',
      category: 'Home',
      action: 'Filtrar promocion',
      label: label,
      // This data is set to undefined in order to clean the dataLayer
      // from the paramaters of previous events
      items: undefined,
      ecommerce: undefined,
      texto_buscado: undefined,
      nombre_aliado: undefined,
      nombre_promocion: undefined,
      categoria_promocion: undefined,
      estado: undefined,
      tipo_recompensa: undefined,
      tipo_negocio: undefined
    },
    dataLayerName: skin === 'COPPEL' ? 'CoppelDataLayer' : 'DataLayer'
  }
  TagManager.dataLayer(tagManagerArgs)
}

export const searchPromotionDataLayer = (search, skin) => {
  const tagManagerArgs = {
    dataLayer: {
      event: 'ga_event',
      category: 'Home',
      action: 'Buscar promocion',
      label: 'busqueda',
      texto_buscado: search,
      // This data is set to undefined in order to clean the dataLayer
      // from the paramaters of previous events
      items: undefined,
      ecommerce: undefined,
      nombre_aliado: undefined,
      nombre_promocion: undefined,
      categoria_promocion: undefined,
      estado: undefined,
      tipo_recompensa: undefined,
      tipo_negocio: undefined
    },
    dataLayerName: skin === 'COPPEL' ? 'CoppelDataLayer' : 'DataLayer'
  }
  TagManager.dataLayer(tagManagerArgs)
}

export const viewLocationDataLayer = (label, itemData, dictionary, skin) => {
  const tagManagerArgs = {
    dataLayer: {
      event: 'ga_event',
      category: 'Home',
      action: 'Ver locacion',
      label: label,
      nombre_aliado: itemData.dv_name,
      nombre_promocion: itemData.venue.name,
      categoria_promocion: itemData.dv_category,
      // FIXME: Set to undefined until the info is obtained from the backend
      estado: undefined,
      tipo_recompensa: dictionary.CARDS[itemData.quickType],
      tipo_negocio: dictionary.CARDS[itemData.venue.business_type],
      // This data is set to undefined in order to clean the dataLayer
      // from the paramaters of previous events
      items: undefined,
      ecommerce: undefined,
      texto_buscado: undefined
    },
    dataLayerName: skin === 'COPPEL' ? 'CoppelDataLayer' : 'DataLayer'
  }
  TagManager.dataLayer(tagManagerArgs)
}
export const filtersDataLayer = (
  label,
  categories,
  priceLevel,
  rewardType,
  businessType,
  dictionary,
  skin
) => {
  const translatedCats = categories.map((category) =>
    INDUSTRIES_ES.find((industry) => industry.slug === category)
  )
  const categoriesString = translatedCats
    .map((category) => category.label)
    .concat(priceLevel)
    .join(', ')

  const tagManagerArgs = {
    dataLayer: {
      event: 'ga_event',
      category: 'Filtros',
      action: 'Clic filtros',
      label: label,
      categoria_promocion:
        categoriesString.length === 0 ? undefined : categoriesString,
      tipo_recompensa: dictionary.TABS[`modal_reward_type_${rewardType}`],
      tipo_negocio: dictionary.CARDS[businessType],
      // This data is set to undefined in order to clean the dataLayer
      // from the paramaters of previous events
      items: undefined,
      ecommerce: undefined,
      texto_buscado: undefined,
      nombre_aliado: undefined,
      nombre_promocion: undefined,
      estado: undefined
    },
    dataLayerName: skin === 'COPPEL' ? 'CoppelDataLayer' : 'DataLayer'
  }
  TagManager.dataLayer(tagManagerArgs)
}

export const clickViewRewards = (itemData, dictionary, skin) => {
  const tagManagerArgs = {
    dataLayer: {
      event: 'ga_event',
      category: 'Home',
      action: 'Clic ver recompensas',
      label: 'Clic ver recompensas',
      nombre_aliado: itemData.dv_name.split('-')[0],
      categoria_promocion: itemData.dv_category,
      tipo_negocio: dictionary.CARDS[itemData.venue.business_type],
      // This data is set to undefined in order to clean the dataLayer
      // from the paramaters of previous events
      tipo_recompensa: undefined,
      ecommerce: undefined,
      texto_buscado: undefined,
      nombre_promocion: undefined,
      // FIXME: Set to undefined until the info is obtained from the backend
      estado: undefined
    },
    dataLayerName: skin === 'COPPEL' ? 'CoppelDataLayer' : 'DataLayer'
  }
  TagManager.dataLayer(tagManagerArgs)
}
